import {
  SET_M_YEAR_END_PO,
  SET_M_YEAR_END_PO_FAIL,
  ERROR_M_YEAR_END_PO_FAIL,
  GET_EXPORT_REPORT,
  UPDATE_LOCK_PO_MODAL,
  UPLOAD_FILE,
  UPLOAD_SUCCESS
}
  from '../actions/actionTypes';

const initialState = {
  contractPOData: [],
  contractPOModal: {},
  errorMsg: "",
  m_contractPOData: [],
  contractPOerrorMsg: "",
  uploadResult: [],
}

function ContractPORedux(state = initialState, action) {
  switch (action.type) {

    case SET_M_YEAR_END_PO:
      return {
        ...state,
        contractPOData: action.payload,
        errorMsg: ""
      }

    case SET_M_YEAR_END_PO_FAIL:
      return {
        ...state,
        errorMsg: action.data
      }

    case ERROR_M_YEAR_END_PO_FAIL:
      return {
        ...state,
        contractPOerrorMsg: action.payload,
      }
    case GET_EXPORT_REPORT:
      return {
        ...state,
        resultExport: action.payload
      };
    case UPDATE_LOCK_PO_MODAL:
      return {
        ...state,
        lockPOModal: action.data
      }
    case UPLOAD_FILE:
      return {
        ...state,
        uploadResult: action.payload
      }
    case UPLOAD_SUCCESS:
      return {
        ...state,
        saveUploadResult: action.payload
      }
    default:
      return state;
  }
}

export default ContractPORedux